class CollectionChartTab extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      let otherTabs = getSiblings(this);
      otherTabs.forEach(tab => {
        tab.removeAttribute('data-active-tab');
      });
      this.setAttribute('data-active-tab', '');

      let activeTabId = this.getAttribute('for');
      let activeTab = document.getElementById(activeTabId);
      let otherTabContents = getSiblings(activeTab);
      otherTabContents.forEach(tab => {
        tab.setAttribute('hidden', '');
      });
      activeTab.removeAttribute('hidden');
    });
    let getSiblings = function(e) {
      let siblings = [];
      if (!e.parentNode) {
        return siblings;
      }
      let sibling = e.parentNode.firstChild;
      while (sibling) {
        if (sibling.nodeType === 1 && sibling !== e) {
          siblings.push(sibling);
        }
        sibling = sibling.nextSibling;
      }
      return siblings;
    };
  }
}
customElements.define('collection-chart-tab', CollectionChartTab);
